import Templates from './Templates';
import WithTemplatesFetch from './hocs/withTemplatesFetch';

export default WithTemplatesFetch(Templates);
